/**
 * Resolve full hospital letterhead from API profile + session (auto — no manual PDF setup).
 */

export function hospitalInitials(name) {
  if (!name) return 'H';
  const words = String(name).trim().split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return words.slice(0, 2).map((w) => w[0]).join('').toUpperCase();
}

export function resolveHospitalForLetterhead(hospital, user) {
  const fromApi = hospital && typeof hospital === 'object' ? { ...hospital } : {};
  const name = fromApi.name || (typeof hospital === 'string' ? hospital : '') || user?.hospital || 'Hospital';
  return {
    ...fromApi,
    hospitalId: fromApi.hospitalId || user?.hospitalId || '',
    name,
    city: fromApi.city || '',
    state: fromApi.state || '',
    addressLine1: fromApi.addressLine1 || '',
    addressLine2: fromApi.addressLine2 || '',
    pincode: fromApi.pincode || '',
    phone: fromApi.phone || '',
    email: fromApi.email || '',
    gstin: fromApi.gstin || '',
    tagline: fromApi.tagline || '',
    regNo: fromApi.regNo || '',
    website: fromApi.website || '',
    logoUrl: fromApi.logoUrl || '',
    letterheadColor: fromApi.letterheadColor || '#1e40af',
    logoInitials: fromApi.logoInitials || hospitalInitials(name),
    letterheadOnPdf: fromApi.letterheadOnPdf !== false,
  };
}

/** Hospital setting — letterhead on PDFs (default on). */
export function isLetterheadOnPdf(hospital) {
  if (!hospital || typeof hospital !== 'object') return true;
  return hospital.letterheadOnPdf !== false;
}

export function hasLetterheadAddress(h) {
  return !!(h?.addressLine1 || h?.city);
}
